<template>
	<!-- <f7-page id="addContactGroupContactList"> -->
  <div class="page" id="contactDebtorList">
    <!--
    <bottom-toolbar></bottom-toolbar>
    <f7-toolbar class="contactListToolbar" style="bottom:44px;">
      <f7-link class="streammindContactListButton yellowButton okButtonContactList" @click="goBack">OK</f7-link>
      <f7-link class="streammindContactListButton yellowButton" @click="cancel">Cancel</f7-link>
    </f7-toolbar>
  -->
    <div class="page-content">
  		<!-- <page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverContacts" subNavTitle="DebtorList" :menuAccess="false"></page-nav-bar> -->
      <!-- <f7-navbar title="My Contacts"></f7-navbar> -->

      <div class="navbar">
          <div class="navbar-inner">

          </div>

      </div>
  		<f7-searchbar class="search"
  			cancel-link="Cancel"
  			search-list="#add-contact-group-contact-list"
  			placeholder="Search in contact list">
  		</f7-searchbar>
      <f7-list class="addGroupMemberGroupList" id="add-contact-group-contact-list" contacts>
        <f7-list-group v-for="(group, key) in this.contactAlphabetList" :key="key">
          <f7-list-item :title="key" group-title></f7-list-item>
          <li v-for="contact in group" v-on:change="changeItem()">
            <label class="label-checkbox item-content">
              <!-- Checked by default -->
              <input class="inputContact" type="checkbox" name="addContactGroupContactListCheckbox" :value="contact.id" v-model="contactSelected">
              <div class="item-media">
                <i class="icon icon-form-checkbox"></i>
              </div>
              <div class="item-inner">
                <div class="item-title">{{contact.label}}</div>
              </div>
            </label>
          </li>
        </f7-list-group>
      </f7-list>
      <div class="row justify-content-start">
        <div class="offset-md-5 col-md-3">
          <button class="buttonWidth streammindContactListButton button-inner-color okButtonContactList" @click="goBack">
            <span>OK</span>
          </button>
        </div>
        <div class="col-md-3">
          <button class="buttonWidth streammindContactListButton button-inner-color" @click="cancel">
            <span>Cancel</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="toolbarPageBottomBlank"></div>
      </div>
      <div class="layoutBottomContactList"></div>
      <!-- <f7-toolbar class="contactListToolbar">
        <f7-link class="streammindContactListButton yellowButton okButtonContactList" @click="goBack">OK</f7-link>
        <f7-link class="streammindContactListButton yellowButton" @click="cancel">Cancel</f7-link>
      </f7-toolbar> -->
	<!-- </f7-page> -->
    </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  name: 'addContactGroupContactList',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      contactSelected: [],
      contactAlphabetList: []
    }
  },
  mounted () {
    let that = this
    // that.contactSelected = this.$engine.services.payments.contactDebtorList
    var contactAlphabetListObject = {}
    for (var j = 0; j < this.$engine.contacts.get().length; j++) {
      var firstLetter = this.$engine.contacts.get(j).label.substr(0, 1).toUpperCase()
      if (!contactAlphabetListObject.hasOwnProperty(firstLetter)) {
        contactAlphabetListObject[firstLetter] = []
      }
      contactAlphabetListObject[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id, typeContact: this.$engine.contacts.get(j).typeContact})
      contactAlphabetListObject[firstLetter].sort()
    }
    that.contactAlphabetList = this.orderKeys(contactAlphabetListObject)
    this.contactSelected = this.$settings.addContactGroupContactSelected
  },
  created () {
  },
  methods: {
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeItem () {
      let that = this
      that.contactSelected = []
      this.Dom7('input[name=addContactGroupContactListCheckbox]:checked').each(function () {
        that.contactSelected.push(that.Dom7(this).val())
      })
      // this.$engine.services.payments.contactDebtorList = that.contactSelected
    },
    goBack () {
      this.$engine.settings.set({addContactGroupContactSelected: this.contactSelected})
      this.$bus.emit('refresh-add-contact-group-contact-selected', this.contactSelected)
      this.$f7.mainView.router.back()
    },
    cancel () {
      this.$f7.mainView.router.back()
    }
  }
}
</script>

<style scoped>
@media (min-width: 993px) {
  .addGroupMemberGroupList {
    margin-left: 260px !important;
  }
  .search {
    margin-top: 79px !important;
  }
}

.buttonWidth {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// CMAddContactGroupContactList.vue?7b3e03be